module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{"author":"/people/luke-fagg/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/authors-luke-fagg.json
// module id = 1618
// module chunks = 194115596745226